import moment from 'moment'

const DISTANCE_TO_SATELLITE_KM = 1500000
const MINUTES_TO_ADJUST = 90

function calculateTimeToEarth(speedKmPerS: number) {
  return DISTANCE_TO_SATELLITE_KM / speedKmPerS
}

function getSpeedAtEarth(speed: any) {
  const startIndex = speed.length - MINUTES_TO_ADJUST
  const lastSpeedTime = speed[speed.length - 1][0]
  return speed
    .slice(startIndex)
    .map((measurement: any) => {
      const currentSpeed = measurement[1]
      const measureTime = measurement[0]
      const secondsToEarth = calculateTimeToEarth(currentSpeed)

      const adjustedTime = moment.utc(measureTime).add(secondsToEarth, 'seconds').unix() * 1000

      if (adjustedTime > lastSpeedTime) {
        return [adjustedTime, currentSpeed]
      } else {
        return null
      }
    })
    .filter((value: any) => value)
}

const SPEED_TIME = 0
const SPEED_VALUE = 2
const DENSITY = 1

function getDensityAtEarth(data: any) {
  const startIndex = data.length - MINUTES_TO_ADJUST
  const lastDensityTime = moment.utc(data[data.length - 1][0]).unix() * 1000
  return data
    .slice(startIndex)
    .map((measurement: any) => {
      const currentDensity = measurement[DENSITY]
      const currentSpeed = measurement[SPEED_VALUE]
      const measureTime = measurement[SPEED_TIME]
      const secondsToEarth = calculateTimeToEarth(currentSpeed)

      const adjustedTime = moment.utc(measureTime).add(secondsToEarth, 'seconds').unix() * 1000

      if (adjustedTime > lastDensityTime) {
        return [adjustedTime, parseFloat(currentDensity)]
      } else {
        return null
      }
    })
    .filter((value: any) => value)
}

export function getSpeedConversionMap(data: any) {
  const startIndex = data.length - MINUTES_TO_ADJUST
  return data.slice(startIndex).reduce((prev: any, measurement: any) => {
    const measureTime = measurement[SPEED_TIME]
    const currentSpeed = measurement[SPEED_VALUE]
    const secondsToEarth = calculateTimeToEarth(currentSpeed)
    prev[measureTime] = moment.utc(measureTime).add(secondsToEarth, 'seconds').unix() * 1000
    return prev
  }, {})
}

export function formatDensityData(data: any) {
  const density = data.map((d: any) => {
    return [moment.utc(d[SPEED_TIME]).unix() * 1000, parseFloat(d[DENSITY])]
  })

  const densityAtEarth = getDensityAtEarth(data)

  const latest = data[data.length - 1]

  return {
    data: density,
    densityAtEarth: densityAtEarth,
    latest: {
      time: latest[SPEED_TIME],
      value: parseFloat(latest[DENSITY]),
    },
  }
}

export function formatSpeedData(data: any) {
  const speed = data.map((d: any) => {
    return [moment.utc(d[SPEED_TIME]).unix() * 1000, parseFloat(d[SPEED_VALUE])]
  })

  const speedAtEarth = getSpeedAtEarth(speed)

  const latest = data[data.length - 1]

  return {
    data: speed,
    speedAtEarth: speedAtEarth,
    latest: {
      time: latest[SPEED_TIME],
      value: parseInt(latest[SPEED_VALUE], 10),
    },
  }
}

const BZ_TIME = 0
const BZ_VALUE = 3

export function formatBzData(data: any) {
  const bZ = data.map((d: any) => {
    return [moment.utc(d[BZ_TIME]).unix() * 1000, parseFloat(d[BZ_VALUE]), d[BZ_TIME]]
  })
  const latest = data[data.length - 1]

  return {
    data: bZ,
    start: data[0][BZ_TIME],
    latest: {
      time: latest[BZ_TIME],
      value: latest[BZ_VALUE],
    },
  }
}

export function adjustBz(allData: any, conversions: any) {
  const lastTime = allData[allData.length - 1][0]
  const startIndex = allData.length - MINUTES_TO_ADJUST

  const newSeries = allData
    .slice(startIndex)
    .map((d: any) => {
      const adjustedTime = conversions[d[2]]
      return adjustedTime && adjustedTime > lastTime ? [adjustedTime, d[1]] : null
    })
    .filter((d: any) => Boolean(d))

  return {
    bZAtEarth: newSeries,
  }
}

const K_INDEX_TIME = 0
const K_INDEX_VALUE = 1

export function formatKIndexData(data: any) {
  const kIndexData = data.map((d: any) => {
    return [moment.utc(d[K_INDEX_TIME]).unix() * 1000, parseInt(d[1], 10)]
  })
  const latest = data[data.length - 1]
  return {
    data: kIndexData,
    latest: {
      time: latest[K_INDEX_TIME],
      value: latest[K_INDEX_VALUE],
    },
  }
}

export function filterMagnetometer(data: any, period: any) {
  const timeLimit = moment().subtract(period, 'hour').unix() * 1000
  return data.filter((d: any) => {
    return d[0] > timeLimit
  })
}

export function getMagnetometerChange(data: any) {
  if (!data[data.length - 1])
    // ToDo: Fix properly
    return

  const lastTime = data[data.length - 1][0]
  const last15Minutes = moment(lastTime).subtract(15, 'minute').unix() * 1000
  const values = data.filter((d: any) => {
    return d[0] > last15Minutes
  })
  const start = values[0][1]
  const end = values[values.length - 1][1]
  const diff = end - start
  return {
    time: lastTime,
    value: diff.toFixed(1),
  }
}
